import { BaseService } from "./BaseService";
import { FAQ } from "@/types/faq";
import {
  IFAQService,
  FAQFilters,
  CreateFAQDto,
  UpdateFAQDto,
  FAQFindAllResponse,
  ReorderDto,
} from "./interfaces/IFAQService";

class FAQService extends BaseService implements IFAQService {
  private basePath = "/faqs";

  constructor() {
    super();
  }

  async getAll(filters: FAQFilters): Promise<FAQFindAllResponse> {
    return this.get<FAQFindAllResponse>(this.basePath, filters);
  }

  async create(data: CreateFAQDto): Promise<FAQ> {
    return this.post<FAQ>(this.basePath, data);
  }

  async update(id: string, data: UpdateFAQDto): Promise<FAQ> {
    return this.patch<FAQ>(`${this.basePath}/${id}`, data);
  }

  async deleteFAQ(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }

  async reorder(data: ReorderDto): Promise<void> {
    return this.post<void>(`${this.basePath}/reorder`, data);
  }
}

export const faqService = new FAQService();
